module.exports = __webpack_public_path__ + "assets/img/block-right-hover-019cedb9.png";